import { Link, Outlet } from "react-router-dom";
import Navbar from "./Navbar";
import StyledNavbar from "./StyledNavbar";

const SharedContent = () => {
  return (
    <>
      <StyledNavbar />
      <Outlet />
    </>
  );
};
export default SharedContent;
